import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

export const ChatDemo = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>
          🤖 AI Chat Bubble Demo
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          This page demonstrates the floating AI chat bubble
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" paragraph>
            Look for the chat icon in the bottom right corner! 🎯
          </Typography>

          <Typography variant="body1" paragraph>
            The chat bubble will appear on all pages except profile pages.
          </Typography>

          <Typography variant="body1" paragraph>
            On mobile, it sticks to the bottom and expands to full width.
          </Typography>
        </Box>

        <Box
          sx={{
            p: 3,
            bgcolor: 'action.hover',
            borderRadius: 2,
            border: '2px dashed',
            borderColor: 'primary.main',
          }}
        >
          <Typography variant="h6" color="primary" gutterBottom>
            Features
          </Typography>
          <Typography variant="body2" component="div">
            ✨ Liquid glass effect with backdrop blur
            <br />
            🏠 House-shaped submit button
            <br />
            📱 Responsive mobile design
            <br />
            🎨 Smooth animations and transitions
            <br />
            💬 Real-time chat interface
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};
